export default "__VITE_ASSET__CZ5U6e2i__"